
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getRoleList, getInviteUser, getBatchInviteUser } from '@/api/users';
import { getDepartmentList } from '@/api/company';
import { UserModule } from '@/store/modules/user';
import { parseTime } from '@/utils/index';
import { lAreaData } from '@/const/LAreaData';
import html2canvas from 'html2canvas';
var QRCode = require('qrcode');

@Component({
  name: 'SetInvite',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })dialogInviteVisible!:Boolean;

  @Prop({
    type: Boolean,
    default: false
  })dialogInviteDept!:Boolean;

  private invitation:any = {
    dept: '',
    role: '',
    url: '',
    expire: '',
  }
  private qrCode='';
  private toCode=''
  private invitationRoleOptions = []

  private inviteTypeSelected = '1'
  private checkboxGroup = ['link', 'code']
  private deptInviteExpire = ''
  private formInlineInvite = {
    name: '',
    area: ''
  }
  private tableData = []
  private selectionInvite = []

  // 省市区元数据
  private lAreaData = lAreaData;
  private defaultProps:any = {
    children: 'child',
    label: 'name',
    value: 'id'
  }
  private isSearchDept=false;
  created() {
    this.getDepartmentList();
    this.getRoleList();
    this.getInviteUser();
  }
  private handleSearch() {
    this.isSearchDept = true;
    this.getDepartmentList();
  }
  private handleClear() {
    this.isSearchDept = false;
    this.formInlineInvite = {
      name: '',
      area: ''
    };
    this.getDepartmentList();
  }

  private props:any = {
    checkStrictly: true,
    value: 'dept_id',
    label: 'name',
    lazy: true,
    lazyLoad(node:any, resolve:any) {
      const params :any = {
        company_id: UserModule.getCompanyId,
        type: '9', // type=9 查所有部门  type=2查服务部门
        is_multi_level: '1',
        size: 9999

      };
      if (node && node.data && node.data.dept_id) {
        params.dept_pid = node.data.dept_id;
      }
      getDepartmentList(params)
        .then(res => {
          if (res.data && res.data.list) {
            res.data.list.forEach((item:any) => {
              item.leaf = parseInt(item.lower_level_count) === 0;
            });
            resolve(res.data.list);
          } else {
            resolve();
          }
        })
        .catch(err => {
          this.$notify.error({
            title: '错误',
            message: err.msg
          });
        });
    }
  }

  load(tree:any, treeNode:any, resolve:any) {
    const params :any = {
      company_id: UserModule.getCompanyId,
      type: '9', // type=9 查所有部门  type=2查服务部门
      is_multi_level: '1',
      size: 9999

    };
    params.dept_pid = tree.id;
    getDepartmentList(params)
      .then(res => {
        if (res.data && res.data.list) {
          let dataTable:any = res.data.list;
          dataTable.forEach((item:any) => {
            (item as any).hasChildren = parseInt(item.lower_level_count) > 0;
            (item as any).level = item.dept_pids ? parseInt(item.dept_pids.split(',').length + 1) : 1;
          });
          resolve(dataTable);
        } else {
          resolve();
        }
      })
      .catch(err => {
        this.$notify.error({
          title: '错误',
          message: err.msg
        });
      });
  }

  // 生成二维码
  private createQR() {
    if (!this.invitation.url) {
      this.qrCode = '';
      return;
    }

    QRCode.toDataURL(this.invitation.url)
      .then((url : any) => {
        this.qrCode = url;
      })
      .catch((err: any) => {
        let msg = err;
      });
      
  }
  private toQR() {
    if (!this.invitation.url) {
      this.toCode = '';
      return;
    }
    this.setCompanyRoleName();
    this.setCompanyDeptName();
    this.setExpireTime();
    QRCode.toDataURL(this.invitation.url)
      .then((url : any) => {
        this.toCode = url;
      })
      .catch((err: any) => {
        let msg = err;
      });
  }
  // 下载二维码
  get companyName(): string  {
    return UserModule.getCompanyName;
  }

  private companyDeptName='';
  setCompanyDeptName() {
    let dept='';
    if( (this.$refs as any).cascaderDEPT.getCheckedNodes().length>0 ){
      if((this.$refs as any).cascaderDEPT.getCheckedNodes()[0]&&(this.$refs as any).cascaderDEPT.getCheckedNodes()[0].parent){
        dept=(this.$refs as any).cascaderDEPT.getCheckedNodes()[0].parent.data.name+'/'+(this.$refs as any).cascaderDEPT.getCheckedNodes()[0].data.name
      }else{
        dept=(this.$refs as any).cascaderDEPT.getCheckedNodes()[0].data.name
      }
    }
    // let t = UserModule.getCompanyName;
    let dep = '';
    if(dept){
      dep ='部门：'+dept ;
    }
    this.companyDeptName = dep;
    // return dep;
  }
  private companyRoleName= '';
  setCompanyRoleName() {
    let releName = '';
    if(this.invitation.role.role_name){
      releName = this.invitation.role.role_name
    }
    let role = '';
    if(releName){
      role = '角色：'+releName;
    }
    this.companyRoleName = role;
    // return role;
  } 
  private expireTime= '';
  setExpireTime() {
    let expireTime = '';
    if(this.invitation.expire && parseInt(this.invitation.expire)>0){
      expireTime = this.invitation.expire
    }
    if(expireTime){
      //将时间戳xpireTime转成年月日 时分日期文本显示
      expireTime = parseTime(parseInt(expireTime), '{y}-{m}-{d} {h}:{i}')+'失效';
    }
    this.expireTime = expireTime;
    // return role;
  } 
  private downloadQr(element: string) {
    if (!this.qrCode) {
      this.$notify.warning({
        title: '',
        message: '请生成二维码再下载'
      });
      return;
    }
    // let dept='';
    // if( (this.$refs as any).cascaderDEPT.getCheckedNodes().length>0 ){
    //   if((this.$refs as any).cascaderDEPT.getCheckedNodes()[0]&&(this.$refs as any).cascaderDEPT.getCheckedNodes()[0].parent){
    //     dept=(this.$refs as any).cascaderDEPT.getCheckedNodes()[0].parent.data.name+'/'+(this.$refs as any).cascaderDEPT.getCheckedNodes()[0].data.name
    //   }else{
    //     dept=(this.$refs as any).cascaderDEPT.getCheckedNodes()[0].data.name
    //   }
    // }
    // let t = UserModule.getCompanyName;
    // let dep = '';
    // if(dept){
    //   dep ='部门：'+dept ;
    // }
    // let role = '角色：'+this.invitation.role.role_name;
    var code:any = document.querySelector(element);

    // code.style.width = '320px';
    // code.style.height = '400px';
    // code.style.textAlign = 'center';
    // let newItemTitle = document.createElement("h3");
    // let textnode = document.createTextNode(t);
    // newItemTitle.appendChild(textnode);
    // code.insertBefore(newItemTitle,code.childNodes[0]);
    
    // if(dept){
    //   let newItemdep = document.createElement("div");
    //   let textnodedep = document.createTextNode(dep);
    //   newItemdep.appendChild(textnodedep);
    //   code.appendChild(newItemdep);
    // }
    // if(this.invitation.role&&this.invitation.role.role_name){
    //   let newItemrole = document.createElement("div");
    //   let textnoderole = document.createTextNode(role);
    //   newItemrole.appendChild(textnoderole);
    //   code.appendChild(newItemrole);
    // }

    let filename = '邀请用户注册码';
    html2canvas(code as any).then(function(canvas:any) {
      let image = new Image();
      image.src = canvas.toDataURL('image/png');
      let a = document.createElement('a');
      a.appendChild(image);
      a.href = image.src;
      a.download = filename;
      a.click();
    });
    // code.removeChild(code.childNodes[0]);
    // code.removeChild(code.childNodes[code.childNodes.length - 1]);
    // if(this.invitation.role&&this.invitation.role.role_name&&dept){
    //   code.removeChild(code.childNodes[code.childNodes.length - 1]);
    // }
    // code.style.width = '180px';
    // code.style.height = '180px';
  }

  // 生成链接
  private createUrl() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.alliance_code = (UserModule.user as any).alliance_code;
    params.agent_code = (UserModule.user as any).agent_code;
    if (this.invitation.dept) {
      params.department_id = this.invitation.dept[this.invitation.dept.length - 1];
    }
    if (this.invitation.role) {
      params.company_role_id = this.invitation.role.id;
    }
    if(this.invitation.expire && parseInt(this.invitation.expire)>0){
      params.expire = parseInt(this.invitation.expire)/1000;
    }
    getInviteUser(params).then(res => {
      if (res.data) {
        //
        this.$set(this.invitation, 'url', res.data.url);
        this.toQR();
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  // 复制链接
  private copyUrl(url:string) {
    if (!url) {
      this.$notify.warning({
        title: '',
        message: '请生成链接在复制'
      });
      return;
    }
    var input = document.createElement('input'); // 直接构建input
    input.value = url; // 设置内容
    document.body.appendChild(input); // 添加临时实例
    input.select(); // 选择实例内容
    document.execCommand('Copy'); // 执行复制
    document.body.removeChild(input); // 删除临时实例
    this.$notify.success({
      title: '',
      message: '复制成功'
    });
  }
  // 批量
  private batchInviteUser() {
    if (this.checkboxGroup.length < 1) {
      this.$notify.warning({
        title: '提示',
        message: '请选择二维码导出类型'
      });
      return;
    }
    if (this.selectionInvite && this.selectionInvite.length < 1) {
      this.$notify.warning({
        title: '提示',
        message: '请选择部门'
      });
      return;
    }
    this.getBatchInviteUser();
  }
  // 批量下载邀请
  private getBatchInviteUser() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.company_name = UserModule.getCompanyName;
    // params.company_short_name = UserModule.company_short_name;
    let deptStr = '';
    for (var dept of this.selectionInvite) {
      deptStr = deptStr + (dept as any).id + ',';
    }
    params.dept_str = deptStr.substring(0, deptStr.length - 1);
    if (this.checkboxGroup.indexOf('link') > -1) {
      params.urlShow = 1;
    } else {
      params.urlShow = 0;
    }
    if (this.checkboxGroup.indexOf('code') > -1) {
      params.codeShow = 1;
    } else {
      params.codeShow = 0;
    }
    if(this.deptInviteExpire && parseInt(this.deptInviteExpire)>0){
      params.expire = parseInt(this.deptInviteExpire)/1000;  
    }
    getBatchInviteUser(params).then(res => {
    }).catch(err => {
      if (!err.msg) {
        let blob = new Blob([err]);
        let fileName = new Date().getTime() + '.pdf';
        if ('download' in document.createElement('a')) {
          // 非IE下载
          let elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          // navigator.msSaveBlob(blob, fileName);
        }
        this.$message.success('下载文件成功');
      } else {
        this.$message.error(err.msg);
      }
    });
  }
  // 获取默认邀请url
  private getInviteUser() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.alliance_code = (UserModule.user as any).alliance_code;
    params.agent_code = (UserModule.user as any).agent_code;
    getInviteUser(params).then(res => {
      if (res.data) {
        this.$set(this.invitation, 'url', res.data.url);
        this.createQR();
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  // 获取部门
  getDepartmentList() {
    const params :any = {
      company_id: UserModule.getCompanyId,
      type: '9', // type=9 查所有部门  type=2查服务部门
      is_multi_level: '1',
      dept_pid: '0',
      size: 9999
    };
    if (this.formInlineInvite.name) {
      params.name = this.formInlineInvite.name;
    }
    if (this.formInlineInvite.area) {
      params.address = this.formInlineInvite.area;
    }
    getDepartmentList(params)
      .then(res => {
        if (res.data) {
          if (!this.isSearchDept) {
            res.data.list.forEach((item:any) => {
              item.leaf = parseInt(item.lower_level_count) === 0;
              (item as any).hasChildren = parseInt(item.lower_level_count) > 0;
              (item as any).level = item.dept_pids ? parseInt(item.dept_pids.split(',').length + 1) : 1;
            });
          }
          this.tableData = res.data.list;
          this.paseData(this.tableData);
        } else {
          this.tableData = [];
        }
      })
      .catch(err => {
        this.$notify.error({
          title: '错误',
          message: err.msg
        });
      });
  }
  private paseData(val:any) {
    for (let i = 0; i < val.length; i++) {
      let cont:any = val[i];
      cont.area = val[i].province_name + val[i].city_name + val[i].district_name;
      // cont.addTimeStr = parseTime(cont.addtime, '{y}-{m}-{d} {h}:{i}');
      this.$set(this.tableData, cont, i);
    }
  }
  // 角色接口
  getRoleList() {
    const params = {
      company_id: UserModule.getCompanyId,
      size: 9999
    };
    getRoleList(params)
      .then(res => {
        if (res.data) {
          this.invitationRoleOptions = (res as any).data.list;
        } else {
          this.invitationRoleOptions = [];
        }
      })
      .catch(err => {
        this.$notify.error({
          title: '错误',
          message: err
        });
      });
  }

  inviteSelectionChange(val: any) {
    this.selectionInvite = val;
  }

  close() {
    this.$emit('close', false);
  }
}
